import { render, staticRenderFns } from "./RCchatHistory.vue?vue&type=template&id=92dc55fe&scoped=true&"
import script from "./RCchatHistory.vue?vue&type=script&lang=js&"
export * from "./RCchatHistory.vue?vue&type=script&lang=js&"
import style0 from "./RCchatHistory.vue?vue&type=style&index=0&id=92dc55fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92dc55fe",
  null
  
)

export default component.exports